import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * accepts both routes: uui.domain.client.rm.RouteIdentifier[] and dates: string[]
 * if you need to revoke an entire day use mode "byDates"
 * otherwise if you just need to revoke a collection of routes use mode "byRoutes"
 */
export const revokeRoutes = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.actions.rpc.route.RevokeRoutesAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/revoke', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/route/revoke', {
      category: 'rpc',
      type: 'rpc/route/revoke',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {revokeRoutes}`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Revoke routes failed`,
      error,
    })
  }
})
